import CollapseIcon from "@redotech/redo-icons/collapse-01.svg";
import { Step } from "@redotech/redo-model/return-flow";
import { combineLabelFromModel } from "@redotech/redo-model/return-flow-step-from-model";
import {
  CombineLabelState,
  isCombineLabelStepValid,
} from "@redotech/redo-model/return-flow-step-valid";
import { BlockLayout } from "@redotech/redo-web/flowchart";
import React from "react";
import { StepType, StepTypeDetailsProps } from "../step";

export const COMBINE_LABEL = (
  Details: React.ComponentType<StepTypeDetailsProps<CombineLabelState>>,
): StepType<CombineLabelState, Step.CombineLabel> => ({
  layout() {
    return BlockLayout.FULL;
  },
  empty: {},

  title: "Combine label",

  customTitle: (state) => state.customTitle,

  description: (state, team) => {
    const methods = [];
    const skuGroupingEnabled =
      team?.settings.returns?.labelCombination?.combineLabelsSkuGroups
        ?.enabled ?? false;
    const sameFulfillmentEnabled =
      team?.settings.returns?.labelCombination
        ?.onlyCombineLabelsFromSameFulfillment ?? false;

    if (skuGroupingEnabled) {
      methods.push("SKU grouping");
    }
    if (sameFulfillmentEnabled) {
      methods.push("Same fulfillment");
    }
    return `Combine method\n${methods.map((m) => `${m}`).join("\n")}`;
  },

  Icon: CollapseIcon,
  iconColor: "success",

  Details(props) {
    return <Details {...props} />;
  },

  downstream: () => [],

  maxDownstream: () => 0,

  fromModel: (model) => combineLabelFromModel(model),

  toModel: (state) => ({
    type: Step.COMBINE_LABEL,
    customTitle: state.customTitle,
  }),

  valid: (state) => isCombineLabelStepValid(state).valid,

  stepDeleted: (state) => state,
});

export { type CombineLabelState } from "@redotech/redo-model/return-flow-step-valid";
